import styled, { css } from 'styled-components';

export type RadioCardsSize = 1 | 2 | 3;

export type RadioCardsProps = {
  $size: RadioCardsSize;
  $orientation: 'vertical' | 'horizontal';
  $espacamentoAutomatico?: boolean;
  $displayGrid?: boolean;
  $totalRadioCards?: number;
  $colunasGrid?: number;
  $espacamentoColunaGrid?: number;
  $espacamentoLinhaGrid?: number;
};

export const RadioCards = styled.div<RadioCardsProps>`
  ${({
    theme,
    $displayGrid,
    $totalRadioCards,
    $colunasGrid,
    $orientation,
    $espacamentoAutomatico,
    $size,
    $espacamentoColunaGrid,
    $espacamentoLinhaGrid,
  }) => {
    if (
      $displayGrid &&
      $totalRadioCards &&
      $colunasGrid &&
      ($espacamentoColunaGrid || $espacamentoLinhaGrid)
    ) {
      const totalLinhas = Math.round($totalRadioCards / $colunasGrid);
      return css`
        display: grid;
        grid-template-rows: repeat(${totalLinhas <= 0 ? 1 : 1}, 1fr);
        grid-template-columns: repeat(${$colunasGrid}, 1fr);
        column-gap: ${$espacamentoColunaGrid ?? 0}px;
        row-gap: ${$espacamentoLinhaGrid ?? 0}px;
      `;
    }

    return css`
      display: flex;
      flex-direction: ${$orientation === 'horizontal' ? 'row' : 'column'};
      flex: 1;
      ${$espacamentoAutomatico
        ? css`
            justify-content: center;
          `
        : ''};
      gap: ${theme.spacing[$size < 2 ? 2 : $size + 1]}px;
    `;
  }}
`;
